module.exports = __webpack_public_path__ + "static/media/andrew_quill.3d932a16.jpg";